export default __webpack_public_path__ + "static/googleCloud-b1b51f0896666cf745f61112aef9bbc6.png";